class SingleProduct {
  constructor() {
    this.variationsFormSelector = '.mad-variations-form';
    this.variationsForm = jQuery(this.variationsFormSelector);

    var resetVariations = jQuery('form.mad-variations-form .reset_variations');
    setTimeout(() => { resetVariations.addClass('initialized'); }, 500);

    var wckPrice = jQuery('.wckalkulator-price');
    if (wckPrice.length && jQuery('.mad-single-product-price').length) {
      jQuery('.mad-single-product-price').prepend(wckPrice)
    }

    jQuery(document).on('click', 'button.mad-add-to-cart__plus-quantity-button, button.mad-add-to-cart__minus-quantity-button', function () {
      var qty = jQuery(this).closest('form.cart').find('.qty');
      var val = parseFloat(qty.val());
      var max = parseFloat(qty.attr('max'));
      var min = parseFloat(qty.attr('min'));
      var step = parseFloat(qty.attr('step'));
      if (jQuery(this).is('.mad-add-to-cart__plus-quantity-button')) {
        if (max && (max <= val)) { qty.val(max); } else { qty.val(val + step); }
      } else {
        if (min && (min >= val)) { qty.val(min); }
        else if (val > 1) { qty.val(val - step); }
      }

      qty.trigger('change');
    });

    // Bei jeder Mengenänderung Preise neu berechnen
    jQuery(document).on('input change', '.mad-add-to-cart .qty', () => {
      this.updateSimplePrice();
      this.updatePrice(); // für Variable Produkte
    });

    // Variation events
    jQuery(document).on('change', this.variationsFormSelector, this.updatePrice.bind(this));
    jQuery(document).on('found_variation', '.variations_form', (e, variation) => {
      this.updateShippingBadgeWithVariation(variation);
      this.updateDiscountBadgeWithVariation(variation);
    });
    jQuery(document).on('reset_data', '.variations_form', () => {
      this.hideShippingBadge();
    });

    this.updateShippingBadgeForSimple();
    this.updateDiscountBadgeForSimple();
    this.updateSimplePrice();

    this.updatePrice();
  }

  // --- Discount Badge helpers ---
  buildDiscountBadgeHtml(percentage) {
    if (!percentage || percentage <= 0) return '';
    return '<span class="mad-price__discount-badge"><span class="mad-price__discount-badge-text">-' + Math.round(percentage) + '%</span></span>';
  }

  updateDiscountBadgeWithVariation(variation) {
    const customDiscount = variation && (variation.discount_percentage || 0);
    let calculatedDiscount = 0;
    if (variation && variation.display_regular_price > 0 && variation.display_price < variation.display_regular_price) {
      calculatedDiscount = Math.round((1 - variation.display_price / variation.display_regular_price) * 100);
    }
    // no-op: badge is already injected inside <ins> by updatePrice(); this is kept for found_variation hook
    const discountToShow = customDiscount > 0 ? customDiscount : calculatedDiscount;
    const textEl = jQuery('.mad-price__discount-badge .mad-price__discount-badge-text');
    if (discountToShow > 0 && textEl.length) {
      textEl.text('-' + discountToShow + '%');
    }
  }

  updateDiscountBadgeForSimple() {
    // no-op: badge is rendered server-side and rebuilt by updateSimplePrice()
  }

  // --- Badge helpers ---
  getBadgeEl() { return jQuery('.mad-price__shipping-badge'); }
  getBadgeTextEl() { return jQuery('.mad-price__shipping-badge .mad-price__shipping-badge-text'); }

  getBadgesConfig() {
    const el = this.getBadgeEl();
    if (!el.length) return [];
    try {
      return JSON.parse(el.attr('data-shipping-badges') || '[]');
    } catch (e) { return []; }
  }

  findBadgeForClass(classId) {
    const configs = this.getBadgesConfig();
    return configs.find(b => parseInt(b.id, 10) === parseInt(classId, 10));
  }

  showShippingBadge(text, iconClass) {
    const el = this.getBadgeEl();
    if (!el.length) return;
    const icon = el.find('i').first();
    if (icon.length && iconClass) icon.attr('class', iconClass);
    const textEl = this.getBadgeTextEl();
    if (textEl.length) textEl.text(text || '');
    el.removeAttr('hidden');
  }

  hideShippingBadge() {
    const el = this.getBadgeEl();
    if (!el.length) return;
    const textEl = this.getBadgeTextEl();
    if (textEl.length) textEl.text('');
    el.attr('hidden', 'hidden');
  }

  updateShippingBadgeWithVariation(variation) {
    const vId = variation && (variation.mad_shipping_class_id || 0);
    const badge = this.findBadgeForClass(vId);
    if (badge) {
      this.showShippingBadge(badge.text, badge.icon);
    } else {
      this.hideShippingBadge();
    }
  }

  updateShippingBadgeForSimple() {
    const root = jQuery('.mad-single-product-price[data-simple-shipping-class-id]');
    if (!root.length) return;
    const sid = parseInt(root.attr('data-simple-shipping-class-id') || '0', 10);
    const badge = this.findBadgeForClass(sid);
    if (badge) {
      this.showShippingBadge(badge.text, badge.icon);
    } else {
      this.hideShippingBadge();
    }
  }


  updateSimplePrice() {
    // Simple Produkt Wrapper
    var $root = jQuery('.mad-add-to-cart--simple');
    if (!$root.length) return;
    var $qtyInput = $root.find('.qty');
    if (!$qtyInput.length) return;
    var qty = parseFloat($qtyInput.val());
    if (isNaN(qty) || qty <= 0) qty = 1;
    var priceSuffix = window.$madSettings?.shop?.product?.price_suffix || '';

    // Build discount badge HTML from data attribute
    var $priceRoot = jQuery('.mad-single-product-price[data-simple-discount-percentage]');
    var discountPct = $priceRoot.length ? parseInt($priceRoot.attr('data-simple-discount-percentage') || '0', 10) : 0;
    var discountBadgeHtml = this.buildDiscountBadgeHtml(discountPct);

    // Preis inkl Steuer
    var $incl = $root.find('.mad-price-incl-tax');
    var baseIncl = parseFloat($incl.data('base-price'));
    var regularIncl = parseFloat($incl.data('regular-price'));
    var isInclOnSale = !isNaN(regularIncl) && regularIncl > baseIncl;
    if (!isNaN(baseIncl)) {
      var totalIncl = baseIncl * qty;
      if (isInclOnSale) {
        var regularInclTotal = regularIncl * qty;
        $incl.html('<del>' + this.formatPrice(regularInclTotal) + '</del> <ins>' + this.formatPrice(totalIncl) + priceSuffix + discountBadgeHtml + '</ins>');
      } else {
        $incl.text(this.formatPrice(totalIncl) + priceSuffix);
      }
    }
    // Preis exkl Steuer wenn vorhanden
    var $excl = $root.find('.mad-price-excl-tax');
    var baseExcl = parseFloat($excl.data('base-price'));
    var regularExclBase = parseFloat($excl.data('regular-price-excl'));
    var isExclOnSale = !isNaN(regularExclBase) && regularExclBase > baseExcl;
    if (!isNaN(baseExcl)) {
      var totalExcl = baseExcl * qty;
      if (isExclOnSale) {
        var regularExclTotal = regularExclBase * qty;
        $excl.html('<del>' + this.formatPrice(regularExclTotal) + '</del> <ins>' + this.formatPrice(totalExcl) + priceSuffix + discountBadgeHtml + '</ins>');
      } else {
        $excl.text(this.formatPrice(totalExcl) + priceSuffix);
      }
    }
  }

  updatePrice() {
    this.variationsForm = jQuery(this.variationsFormSelector);
    if (this.variationsForm.length == 0) return;
    // aktuelle Menge ermitteln
    var qty = 1;
    var qtyInput = this.variationsForm.closest('.mad-add-to-cart').find('.qty');
    if (qtyInput.length) {
      var parsedQty = parseFloat(qtyInput.val());
      if (!isNaN(parsedQty) && parsedQty > 0) {
        qty = parsedQty;
      }
    }
    var currentVariations = this.variationsForm.data('product_variations');
    var selectedOptions = {};
    this.variationsForm.find('.variations select, .variations input[type="text"]').each(function () {
      var attribute = jQuery(this).data('attribute_name') || jQuery(this).attr('name');
      selectedOptions[attribute] = jQuery(this).val();
    });
    // Filter out any wck attributes
    var filteredSelectedOptions = {};
    for (var key in selectedOptions) {
      if (!key.startsWith('wck[')) filteredSelectedOptions[key] = selectedOptions[key];
    }
    var matchingVariations = currentVariations.filter(function (variation) {
      for (var attribute in filteredSelectedOptions) {
        if (filteredSelectedOptions[attribute] && variation.attributes[attribute] !== filteredSelectedOptions[attribute]) {
          return false;
        }
      }
      return true;
    });

    if (matchingVariations.length) {
      var prices = matchingVariations.map(function (variation) { return variation.display_price; });
      var minPrice = Math.min.apply(Math, prices);
      var maxPrice = Math.max.apply(Math, prices);
      var priceSuffix = window.$madSettings?.shop?.product?.price_suffix || '';

      // Gesamtpreise ausrechnen
      var minTotal = minPrice * qty;
      var maxTotal = maxPrice * qty;
      if (minPrice === maxPrice) {
        var regularPrices = matchingVariations.map(function (v) { return v.display_regular_price; });
        var minRegular = Math.min.apply(Math, regularPrices);
        var isOnSale = matchingVariations.length === 1 && minPrice < minRegular;

        // Build discount badge HTML directly from variation prices
        var discountBadgeHtml = '';
        if (isOnSale && minRegular > 0) {
          var discountPct = Math.round((1 - minPrice / minRegular) * 100);
          discountBadgeHtml = this.buildDiscountBadgeHtml(discountPct);
        }

        var inclHtml;
        if (isOnSale) {
          var regularTotal = minRegular * qty;
          inclHtml = '<del>' + this.formatPrice(regularTotal) + '</del> <ins>' + this.formatPrice(minTotal) + priceSuffix + discountBadgeHtml + '</ins>';
        } else {
          inclHtml = this.formatPrice(minTotal) + priceSuffix;
        }
        jQuery('.mad-add-to-cart .mad-price-incl-tax').html(inclHtml);
        var priceExclTax = this.calculatePriceExcludingTax(minPrice, matchingVariations[0].tax_info) * qty;
        var exclHtml;
        if (isOnSale) {
          var regularExcl = this.calculatePriceExcludingTax(minRegular, matchingVariations[0].tax_info) * qty;
          exclHtml = '<del>' + this.formatPrice(regularExcl) + '</del> <ins>' + this.formatPrice(priceExclTax) + priceSuffix + discountBadgeHtml + '</ins>';
        } else {
          exclHtml = this.formatPrice(priceExclTax) + priceSuffix;
        }
        jQuery('.mad-add-to-cart .mad-price-excl-tax').html(exclHtml);
      } else {
        jQuery('.mad-add-to-cart .mad-price-incl-tax').text(
          this.formatPrice(minTotal) + priceSuffix + ' – ' + this.formatPrice(maxTotal) + priceSuffix
        );
        var priceExclTaxMin = this.calculatePriceExcludingTax(minPrice, matchingVariations[0].tax_info) * qty;
        var priceExclTaxMax = this.calculatePriceExcludingTax(maxPrice, matchingVariations[0].tax_info) * qty;
        jQuery('.mad-add-to-cart .mad-price-excl-tax').text(
          this.formatPrice(priceExclTaxMin) + priceSuffix + ' – ' + this.formatPrice(priceExclTaxMax) + priceSuffix
        );
      }
      // Badge nur anzeigen wenn eine konkrete Variation gewählt ist
      if (matchingVariations.length === 1) {
        this.updateShippingBadgeWithVariation(matchingVariations[0]);
        this.updateDiscountBadgeWithVariation(matchingVariations[0]);
      } else {
        this.hideShippingBadge();
      }
    } else {
      this.hideShippingBadge();
    }
  }

  calculatePriceExcludingTax(price, taxInfo) {
    var taxRateMatch = taxInfo && taxInfo.match ? taxInfo.match(/(\d+(\.\d+)?)\s*%/) : null;
    if (taxRateMatch) {
      var taxRate = parseFloat(taxRateMatch[1]);
      return price / (1 + (taxRate / 100));
    }
    return price;
  }

  formatPrice(price) {
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(price);
  }
}

window.$singleProduct = new SingleProduct();
require('./content');
require('./image-gallery');
